import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { AlertTriangleIcon } from 'lucide-react';
export function StickyAlertBar() {
  return <header className="sticky top-0 z-50 bg-pink-500 border-b-4 border-pink-600 shadow-lg animate-pulse-urgent" data-id="element-236">
      <div className="container mx-auto px-4 py-3" data-id="element-237">
        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6" data-id="element-238">
          <div className="flex items-center gap-2" data-id="element-239">
            <AlertTriangleIcon className="w-6 h-6 text-amber-200 animate-flash" aria-hidden="true" data-id="element-240" />
            <span className="text-white font-extrabold text-sm md:text-lg uppercase tracking-wide" data-id="element-241">
              ⚠️ OFERTA TERMINA EN:
            </span>
          </div>
          <CountdownTimer data-id="element-242" />
        </div>
      </div>
    </header>;
}